var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91083 4.41107C7.23626 4.08563 7.7639 4.08563 8.08934 4.41107L13.0893 9.41107C13.4148 9.73651 13.4148 10.2641 13.0893 10.5896L8.08934 15.5896C7.7639 15.915 7.23626 15.915 6.91083 15.5896C6.58539 15.2641 6.58539 14.7365 6.91083 14.4111L11.3216 10.0003L6.91083 5.58958C6.58539 5.26414 6.58539 4.73651 6.91083 4.41107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextMonth);
export default __webpack_public_path__ + "static/media/nextMonth.477a7e5d8303a44a7f9e92dfd653b576.svg";
export { ForwardRef as ReactComponent };